module.exports = __webpack_public_path__ + "static/media/dinner_keith_hands.b0c70a28.jpg";